import { render, staticRenderFns } from "./orderRouting.vue?vue&type=template&id=7d4bd1b4&scoped=true&"
import script from "./orderRouting.vue?vue&type=script&lang=js&"
export * from "./orderRouting.vue?vue&type=script&lang=js&"
import style0 from "./orderRouting.vue?vue&type=style&index=0&id=7d4bd1b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4bd1b4",
  null
  
)

export default component.exports